import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit{
  notifications: any [] = [];

  loading: boolean = false;

  constructor(private apiService: ApiService){

  }

  ngOnInit(){
    this.loadNotificationHistory();
  }

  loadNotificationHistory(){
    this.loading = true;
    this.apiService.getEntity('massive-notifications').subscribe({
      next: (response) => {
        this.notifications = response.notifications;
      },
      error: (err: any) => {
        this.loading = false;
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
